<template>
  <div>
    <div class="content">
      <div class="lald-case__block-head-child d-md-none mb-8">
        <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
        <div class="lald-case__block-head-child-avatar">
          <img
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
          />
        </div>
      </div>
      <div class="lald-case__block">
        <div class="lald-case__block-head">
          <div class="lald-case__block-head-title">
            Результаты диагностики ДЛКЛ
          </div>
          <div class="lald-case__block-head-child d-none d-md-flex">
            <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
            <div class="lald-case__block-head-child-avatar">
              <img
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
              />
            </div>
          </div>
        </div>
        <div class="lald-case__block-body">
          <p class="default-text">
            Определена низкая активность фермента лизосомной кислой липазы в
            сухих пятнах крови у пациента Дениса - 0,001 нМ/ч/пятно (норма
            >0.065 нМ/ч/пятно).
            <br />
            По результатам генетического анализа выявлен вариант мутации гена
            <i style="font-style: italic">LIPA</i> в гомозиготном состоянии.
          </p>
          <div class="lald-case__block-body-button mt-4 button button_orange-gradient" @click="$emit('toStep', 5)">
            Установить диагноз
          </div>
        </div>
      </div>
      <div class="lald-case__tools">
        <div class="lald-case__back" @click="$emit('back')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.25 19.5L3.75 12L11.25 4.5"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
            <path
              d="M5.25 12L20.25 12"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
          Назад
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step5",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/laldICC.scss";

.lald-case {
  &__block {
    &-body {
      &-prop {
        display: grid;
        grid-template-columns: 170px 1fr;
        gap: 60px;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: 16px;
        }

        &-value {
          color: #5c539e !important;
        }
      }
    }
  }
}
</style>